export default (higher_price, lower_price) => Number(lower_price) && Number(lower_price) < Number(higher_price) ?
  Math.ceil(100 - (Number(lower_price) / (Number(higher_price) / 100))) : 0
